import { Injectable } from '@angular/core';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class BetterLoggerService extends LoggerService{

  constructor() { 
    super();
    console.log('BetterLoggerService initialized');
  }
  override log(message: string): void {
    super.log(`***** BetterLoggerService: ${message}`);
  }
}
